<template>
  <div class="data-analyse-table">

    <el-table :data="tableData" style="width: 100%;overflow-y: hidden;"
      :header-cell-style="{textAlign: 'center',color:'#343436',height:'60px'}" :row-style="{height:'60px'}"
      :cell-style="{ textAlign: 'center',color:'#959595'}" :max-height="600" ref="scroll_Table"
      @mouseenter.native="autoScroll(true)" @mouseleave.native="autoScroll(false)" :row-class-name="tableRowClassName">
      <el-table-column prop="Account" label="用户账号">
      </el-table-column>
      <el-table-column prop="Time" label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.Time ? scope.row.Time.substring(11, 20) : '' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
          prop="Price"
          label="报价">
        </el-table-column> -->
      <el-table-column prop="Price" label="成交价格">
      </el-table-column>
      <!-- <el-table-column
          prop="strOpenClose"
          label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.strOpenClose == 'open'" style="color: #11C771;">建仓</span>
            <span v-if="scope.row.strOpenClose == 'close'" style="color:  #FA2314;">平仓</span>
          </template>
        </el-table-column> -->
      <el-table-column prop="strSymbol" label="产品">
        <template slot-scope="scope">
          <span v-if="scope.row.Symbol == 'GOLD'">伦敦金</span>
          <span v-if="scope.row.Symbol == 'SILVER'">伦敦银</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
          prop="strBuySell"
          label="买/卖">
          <template slot-scope="scope">
            <span v-if="scope.row.Command == 'OP_BUY' ">买</span>
            <span v-if="scope.row.Command == 'OP_SELL' ">卖</span>
          </template>
        </el-table-column> -->
      <el-table-column prop="strBuySell" label="订单类型">
        <template slot-scope="scope">
          <span v-if="scope.row.Command == 'OP_BUY'" style="color: #11C771;">多单</span>
          <span v-if="scope.row.Command == 'OP_SELL'" style="color:  #FA2314;">空单</span>
        </template>
      </el-table-column>
      <el-table-column prop="Volume" label="手数">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import {  GetRealTimeOrder } from '@/apis/common'


export default {
data(){
    return{
         // 表格数据
      tableData: [],
    }
},
created(){
  GetRealTimeOrder().then(res => {
   
    if (res) {
      res.map(item => {
        item.Account = String(item.Account).replace(String(item.Account).substring(2, String(item.Account).length - 2), '****')

      })
    }
    this.tableData = res;

    this.autoScroll()
  })
},
methods:{

  tableRowClassName({ row, rowIndex }) {
    if (rowIndex % 2 == 0) {
      return "warning-row";
    } else {
      return "success-row";
    }
  },
  // 设置自动滚动
  autoScroll(stop) {
    const table = this.$refs.scroll_Table
    // 拿到表格中承载数据的div元素
    const divData = table.$refs.bodyWrapper
    // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
    if (stop) {
      //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
      window.clearInterval(this.scrolltimer)
    } else {
      this.scrolltimer = window.setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop + 1 > divData.scrollHeight) {

          // 重置table距离顶部距离
          divData.scrollTop -= 60
          // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
          // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
        }
      }, 150) // 滚动速度
    }
  },
}
}
</script>

<style lang="less" scoped>
  .data-analyse{

    display: flex;
    justify-content: space-between;

    .red {
      color: #FA2314;
    }
    .green {
      color: #11C771;
    }

    &-left {
      width: 428px;
      flex-shrink: 0;

      .data-box {
        background: #fff;
        padding: 30px;

        &:first-child {
          margin-bottom: 25px;
        }

        &-title {
          color: #000;
          font-size: 24px;
          font-weight: 700;

        }
        &-date {
          color: #93939F;
          font-size: 14px;
          margin: 10px 0;
        }

        &-symbl {
          line-height: 40px;

          &-title {
            color: #000;
            font-size: 18px;
            font-weight: 700;
          }

          &-info {
            display: flex;
            align-items: center;

            >span {
              width: 120px;
            }
            &-speed {
              flex: 1;
              position: relative;
              margin-left: 10px;
              height: 16px;
              background: #f5f5f5;
              border-radius: 16px;

              &-ratio {
                position: absolute;
                left: 0;
                top: 0;
                height: 16px;
                background: #FA2314;
                border-radius: 16px;
                background: linear-gradient(to right, #FA2314, #DB2C23);
              }
            }
            &:last-child {
              .data-box-symbl-info-speed-ratio {
                background: linear-gradient(to right, #11C771, #0AAF61);
              }
            }
          }
        }
      }

    }
  
    &-table {
      padding: 30px;
      width: 786px;
      flex-shrink: 0;
      background: #fff;
      box-sizing: border-box;

      &-title {
        font-size: 24px;
        color: #000;
        font-weight: 700;
        margin: 0 0 20px;
      }
             /deep/ .el-table .warning-row {
      
               background: rgba(255, 250, 243, 1);
             }
      
             /deep/.el-table .success-row {
               background: #fff;
             }
             /deep/ .el-table--scrollable-y .el-table__body-wrapper {
               overflow-y: hidden;
             }
        /deep/ .el-table__row{
        height: 76px;
        td {
          &:nth-child(1) {
            color:#000 !important;
            font-weight: 600;
            // border-left: 1px solid #EBEEF5;
            // border-right: 1px solid #EBEEF5;
          }
        //   &:nth-child(3) {
        //     color: #93939F;
        //   }
        }
      }
    }
   
  }
 @media screen and (max-width: 500px) {
  .data-analyse{
     &-table {
      &-title {
        font-size: 12px;
      }
     }
  }
 }
 //---------------- 小屏幕---------------------------
 @media screen and (min-width: 1264px) and (max-width: 1724px) {
  .data-analyse {
  
      display: flex;
      justify-content: space-between;
  
      .red {
        color: #FA2314;
      }
  
      .green {
        color: #11C771;
      }
  
      &-left {
        width: 428px;
        flex-shrink: 0;
  
        .data-box {
          background: #fff;
          padding: 30px;
  
          &:first-child {
            margin-bottom: 25px;
          }
  
          &-title {
            color: #000;
            font-size: 24px;
            font-weight: 700;
  
          }
  
          &-date {
            color: #93939F;
            font-size: 14px;
            margin: 10px 0;
          }
  
          &-symbl {
            line-height: 40px;
  
            &-title {
              color: #000;
              font-size: 18px;
              font-weight: 700;
            }
  
            &-info {
              display: flex;
              align-items: center;
  
              >span {
                width: 120px;
              }
  
              &-speed {
                flex: 1;
                position: relative;
                margin-left: 10px;
                height: 16px;
                background: #f5f5f5;
                border-radius: 16px;
  
                &-ratio {
                  position: absolute;
                  left: 0;
                  top: 0;
                  height: 16px;
                  background: #FA2314;
                  border-radius: 16px;
                  background: linear-gradient(to right, #FA2314, #DB2C23);
                }
              }
  
              &:last-child {
                .data-box-symbl-info-speed-ratio {
                  background: linear-gradient(to right, #11C771, #0AAF61);
                }
              }
            }
          }
        }
  
      }
  
      &-table {
        padding: 30px;
        width: 786px;
        flex-shrink: 0;
        background: #fff;
        box-sizing: border-box;
  
        &-title {
          font-size: 24px;
          color: #000;
          font-weight: 700;
          margin: 0 0 20px;
        }
  
        /deep/ .el-table__row {
          height: 76px;
  
          td {
            &:nth-child(1) {
              color: #000 !important;
              font-weight: 600;
              // border-left: 1px solid #EBEEF5;
              // border-right: 1px solid #EBEEF5;
            }
  
            //   &:nth-child(3) {
            //     color: #93939F;
            //   }
          }
        }
      }
  
    }
 }
</style>